/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalDigitalCertificate = {
  type: 'Enum',
} as const;
